import { V2_OPERATIONS } from "app/store/modules/actions/requests.actions";

export const getRequestList = (store) => store?.requests?.list?.data || [];
export const getRequestFilter = (store) => store?.requests?.filter;
export const getRequestListPage = (store) => store?.requests?.page;
export const getRequestListSelection = (store) => store?.requests?.selection;

export const getSelectedRequest = (store) => store?.requests?.selectedRequest;
export const getRequestLogs = (store) => store?.requests?.logs?.data || [];
export const getRequestComments = (store) => store?.requests?.comments?.data || [];
export const getRequestMessages = (store) => store?.requests?.messages?.data || [];
export const getRequestOperation = (store) => store?.requests?.operation;

export const getFileToPreview = (store) => {
  const { operation } = store.requests;

  if (operation.action === V2_OPERATIONS.PREVIEW) {
    return operation.data;
  }

  return null;
};
